import { render, staticRenderFns } from "./AlertCEMTIF.vue?vue&type=template&id=2b4d73ab&scoped=true&"
import script from "./AlertCEMTIF.vue?vue&type=script&lang=js&"
export * from "./AlertCEMTIF.vue?vue&type=script&lang=js&"
import style0 from "./AlertCEMTIF.vue?vue&type=style&index=0&id=2b4d73ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d73ab",
  null
  
)

export default component.exports